export const COMMENT_START = "COMMENT_START";
export const COMMENT_SUCCESS = "COMMENT_SUCCESS";
export const COMMENT_FAILURE = "COMMENT_FAILURE";
export const COMMENT_CANCEL = "COMMENT_CANCEL";
export const COMMENT_DELETE = "COMMENT_DELETE";